import classNames from 'classnames'
import { ReactElement, RefObject } from 'react'

import { PositionHandle } from '../types'
import { useTransitionStatus, UseTransitionStatusParams } from './useTransitionStatus'

interface TransitionChildProps {
  className: string
}

interface TransitionProps extends Omit<UseTransitionStatusParams, 'isIn'> {
  in: boolean
  className: string
  activeClassName: string
  children: (props: TransitionChildProps, ref: RefObject<PositionHandle>) => ReactElement
}

export const Transition = ({
  in: isIn,
  className,
  activeClassName,
  children,
  ...transitionParams
}: TransitionProps) => {
  const { status, childRef } = useTransitionStatus({ isIn, ...transitionParams })
  const isActive = status === 'entering' || status === 'entered'

  return children(
    { className: classNames(className, isActive ? activeClassName : undefined) },
    childRef,
  )
}
